module.exports = __webpack_public_path__ + "img/1440x600.d35a0d7f.png";